import React from "react";
import styled from "styled-components";
import {
  Na100Package,
  PublicMetric,
} from "../../../models/CompanyprofileModels";

import {
  ElementContainer,
  FlexibleContainer,
  RowContainer,
} from "../../../components/containers/styledComponents";
import { NA100RadarChart } from "./NA100Radar";
import { NA100Accordion } from "./NA100AccordionItem";
import { NA100_TREE, NA100TreeNode } from "./NA100Constants";
import { CompassParagraph } from "../../../components/common/styledComponents";
import { greyText, lightGreyOutline } from "../../../styles";
import { MESSAGES } from "../../../messages";

const Column = styled.div<{ border?: boolean }>`
  flex: 1;
  box-sizing: border-box;
  ${({ border }): string | false | undefined =>
    border && `border-right: 1px solid ${lightGreyOutline};`}
`;

export const TabNA100 = ({
  metricsData,
}: {
  metricsData: PublicMetric[];
}): JSX.Element => {
  return (
    <FlexibleContainer fd="column" w="100%">
      <ElementContainer flexDirection="column" mb={32} pt={12}>
        <CompassParagraph fontSize={14} bold={true}>
          {MESSAGES.COMPANY_PROFILE.NZA.NA100.TITLE}
        </CompassParagraph>
        <CompassParagraph color={greyText}>
          {MESSAGES.COMPANY_PROFILE.NZA.NA100.DESCRIPTION}
        </CompassParagraph>
      </ElementContainer>

      <RowContainer ai="flex-start" jc="flex-start">
        <Column border={true}>
          <FlexibleContainer
            f={1}
            h="300px"
            w="100%"
            ai="center"
            jc="space-between"
            p="0px 32px 0px 0px"
          >
            <NA100RadarChart metricsData={metricsData} />
          </FlexibleContainer>
        </Column>

        <Column>
          <FlexibleContainer
            h="300px"
            ofy="auto"
            fd="column"
            jc="flex-start"
            ai="flex-start"
            ml="24px"
          >
            {NA100_TREE.map((node: NA100TreeNode) => (
              <NA100Accordion
                key={node.id}
                node={node}
                metricsData={metricsData}
                dataPackage={Na100Package.NA100}
              />
            ))}
          </FlexibleContainer>
        </Column>
      </RowContainer>
    </FlexibleContainer>
  );
};
